import GoogleMapApi from '@/api/GoogleMapApi';
import BaseService from '@/services/BaseService';

class GoogleMapService extends BaseService {

	async getAsync (...args: Parameters<typeof GoogleMapApi.get>) {
		const { data } = await GoogleMapApi.get(...args);
		return data;
	}

}

const googleMapServiceSingleton = new GoogleMapService();

export default function useGoogleMapService () {
	return googleMapServiceSingleton;
}
